/* Version: 3.5.155 */
'use client';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import canadianTheme from '../theme/canadianTheme.js';

function useTheme() {
  var contextTheme = useContext(ThemeContext);
  return contextTheme ? contextTheme : canadianTheme;
}

export { useTheme as default };
